import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeMain from '@/views/home/HomeMain';
import Home from '@/views/home/Home';
import MobileHome from '@/views/home/MobileHome';
import News from '@/views/news';
import NewsDetails from '@/views/news/componets/NewsDetails.vue';
import FoundationProject from '@/views/foundationProject';
import SectorList from '@/views/foundationProject/sectorList';
import FoundationProjectDetails from '@/views/foundationProjectDetails';
import SpecialFund from '@/views/specialFund';
import SpecialFundDetails from '@/views/specialFund/specialFundDetails';
import SpecialFundNewsDetails from '@/views/specialFund/specialFundNewsDetails';
import OrganizationalProfile from '@/views/organizationalProfile';
import FoundationIntroduction from '@/views/organizationalProfile/foundationIntroduction';
import FoundingDirectorUnit from '@/views/organizationalProfile/foundingDirectorUnit';
import OrganizationStructure from '@/views/organizationalProfile/organizationStructure';
import Council from '@/views/organizationalProfile/council';
import KidsGallery from '@/views/kidsGallery';
import KidsGalleryDetail from '@/views/kidsGallery/kidsGalleryDetail';
import ToDownload from '@/views/toDownload';
import ContactUs from '@/views/contactUs';
import store from '../store/index'
import i18n from '@/i18n';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: i18n.t('Home'),
    component: Home,
  },
  {
    path: '/HomeMain',
    name: i18n.t('HomeMain'),
    component: HomeMain,
  },
  {
    path: '/MobileHome',
    name: i18n.t('MobileHome'),
    component: MobileHome,
  },
  {
    path: '/news',
    name: i18n.t('News'),
    component: News,
  },
  {
    path: '/newsDetails',
    name: i18n.t('News'),
    component: NewsDetails,
  },
  {
    path: '/organizationalProfile',
    name: i18n.t('OrganizationalProfile'),
    component: OrganizationalProfile,
    children: [
      {
        path: 'foundationIntroduction',
        name: i18n.t('OrganizationalProfile'),
        component: FoundationIntroduction,
      },
      {
        path: 'foundingDirectorUnit',
        name: i18n.t('OrganizationalProfile'),
        component: FoundingDirectorUnit,
      },
      {
        path: 'organizationStructure',
        name: i18n.t('OrganizationalProfile'),
        component: OrganizationStructure,
      },
      {
        path: 'council',
        name: i18n.t('OrganizationalProfile'),
        component: Council,
      },
    ],
  },
  {
    path: '/foundationProject',
    name: i18n.t('FoundationProject'),
    component: FoundationProject,
  },
  {
    path: '/foundationProject/sectorList',
    name: i18n.t('FoundationProject'),
    component: SectorList,
  },
  {
    path: '/foundationProjectDetails',
    name: i18n.t('FoundationProject'),
    component: FoundationProjectDetails,
  },
  {
    path: '/specialFund',
    name: i18n.t('SpecialFund'),
    component: SpecialFund,
  },
  {
    path: '/specialFundDetails',
    name: i18n.t('SpecialFund'),
    component: SpecialFundDetails,
  },
  {
    path: '/specialFundNewsDetails',
    name: i18n.t('SpecialFund'),
    component: SpecialFundNewsDetails,
  },
  {
    path: '/kidsGallery',
    name: i18n.t('KidsGallery'),
    component: KidsGallery,
  },
  {
    path: '/kidsGalleryDetail',
    name: i18n.t('KidsGallery'),
    component: KidsGalleryDetail,
  },
  {
    path: '/toDownload',
    name: i18n.t('Download'),
    component: ToDownload,
  },
  {
    path: '/contactUs',
    name: i18n.t('ContactUs'),
    component: ContactUs,
  },
  // {
  //   path: '/article',
  //   name: 'article',
  //   component: () =>
  //     import(/* WebpackChunkName: "article" */ '@/views/article/Article'),
  // },
  // {
  //   path: '/search',
  //   name: 'search',
  //   component: () =>
  //     import(/* WebpackChunkName: "search" */ '@/views/search/Serach'),
  // },
];

// 解决携带参数在同页面跳转时，路由报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
	mode:'history',
  routes,
});

router.beforeEach((to, from, next) => {
  // console.log("to",to);
  store.commit('updateClickMenuName', to.name);
  store.commit('updateClickMenuUrl', to.path);
  // localStorage.setItem('clickMenuName', to.name);
  next();
});

export default router;
